module.exports = {
          srcSet: __webpack_public_path__ + "e92a8811450e27b6c27803cb5fc69437-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "e92a8811450e27b6c27803cb5fc69437-120.png",width: 120,height: 144}],
          src: __webpack_public_path__ + "e92a8811450e27b6c27803cb5fc69437-120.png",
          toString:function(){return __webpack_public_path__ + "e92a8811450e27b6c27803cb5fc69437-120.png"},
          
          width: 120,
          height: 144
        }